import { render } from "./paginationOld.vue?vue&type=template&id=51c9aaca&ts=true"
import script from "./paginationOld.vue?vue&type=script&lang=ts"
export * from "./paginationOld.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__